angular.
module("dx.webapp.onlineResources").
controller("DxOnlineResourceEntryController", function OnlineResourceEntry(
	$window,

	DX_RESOURCE_TYPE,
	DX_NAVIGATION_RESTRICTION

) {
	"use strict";

	var self = this;

	this.DX_RESOURCE_TYPE = DX_RESOURCE_TYPE;
	this.DX_NAVIGATION_RESTRICTION = DX_NAVIGATION_RESTRICTION;

	this.openLink = function openLink() {
		if (self.openResourceInTab) {
			$window.open(self.onlineResource.url, "_blank");
		} else {
			self.addOrEditOnlineResource();
		}
	};
});
